enum ErrorConstants {
  DUPLICATE_HIRING_SITES = 'This Hiring Site cannot be added because a Hiring Site with this address exists already. Please add a unique Hiring Site address.',
  GENERAL_ERROR = 'Unexpected error while processing request. Please try again.',
  REJECT_ENROLLMENT_ERROR = 'The enrollment was unable to be rejected. Please wait a few minutes and try again.',
  RESEND_MOU_EMAIL_ERROR = 'MOU Signatory email was unable to be sent. Please wait a few minutes and try again.',
  DOWNLOAD_MOU_ERROR = 'We are unable to process your request. Please contact your agent to obtain a copy of your signed MOU.',
  SELECT_CSV_FILE = 'You must select a file.',
  FILE_SIZE_EXCEED_1MB = 'File size must not exceed 1 MB.',
  FILE_NOT_CSV_FORMAT = 'File format must be a CSV.',
  FILE_EXCEED_1000_ROWS = 'CSV file must not exceed 1000 rows.',
  CSV_FORMAT_ERROR = 'CSV must meet format requirements.',
}

export default ErrorConstants;
